import {
  SET_USER,
  GET_USERS,
  LOADING_GET_USERS,
  REMOVE_USER,
  UPDATE_USER,
} from "../types";

const INITIAL_STATE = {
  user: {},
  users: [],
  loadingGetUsers: false,
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_USER:
      return { ...state, user: action.payload };
    case UPDATE_USER:
      const indx = state.users.findIndex((el) => el._id === action.id);
      const user = { ...state.user, ...action.payload };
      let cpy = [...state.users];
      let users = state.users;
      if (indx !== -1) {
        cpy[indx] = user;
        users = cpy;
      }
      return { ...state, user, users };
    case GET_USERS:
      return { ...state, users: action.payload };
    case LOADING_GET_USERS:
      return { ...state, loadingGetUsers: action.payload };
    case REMOVE_USER:
      const newUsers = state.users.filter((el) => el._id !== action.payload);
      return {
        ...state,
        users: newUsers,
      };

    default:
      return state;
  }
};

export default userReducer;
